/**
 * Категории, которые человек уже давал (14.10.2026).
 *
 * Поменял у позиции чека категорию — в следующем чеке та же позиция встаёт
 * туда же сама; то же у операции из выписки банка с тем же названием. Раньше
 * правка жила только в той покупке: следующий чек начинался заново, с
 * «Продуктов» и догадки модели, и владелец поправлял одно и то же второй раз.
 *
 * Отдельной памяти нет — она собирается из записанных покупок: у каждой есть
 * позиции и категория, и на другое устройство они приезжают вместе. Побеждает
 * последняя запись: человек передумал — значит, теперь так. Модель такие
 * позиции не трогает: выбор человека важнее её догадки.
 */
import type { Category } from './categories.js';
import type { Tx } from './store.js';

/** Название для сравнения: без регистра, «ё», кавычек и лишних пробелов. */
export const nameKey = (s: string): string => s.toLowerCase().replace(/ё/g, 'е')
  .replace(/[«»"“”]/g, '').replace(/\s+/g, ' ').trim();

export interface CategoryMemory {
  /** Позиция чека → категория. */
  items: Map<string, string>;
  /** Название операции из выписки банка → категория. */
  titles: Map<string, string>;
}

export function rememberedCategories(txs: readonly Tx[], categories: readonly Category[]): CategoryMemory {
  const live = new Set(categories.filter((c) => !c.archived && (c.kind ?? 'expense') === 'expense').map((c) => c.id));
  const items = new Map<string, string>();
  const titles = new Map<string, string>();
  const ordered = txs
    .filter((t) => t.type === 'expense' && t.categoryId !== undefined && live.has(t.categoryId))
    .sort((a, b) => a.occurredAt.localeCompare(b.occurredAt));
  for (const t of ordered) {
    for (const i of t.items ?? []) {
      const key = nameKey(i.name);
      if (key) items.set(key, t.categoryId!);
    }
    // Название из банка записывается заметкой; комментарий человека — после « — ».
    if (t.source === 'bank_screen' && t.note) {
      const key = nameKey(t.note.split(' — ')[0] ?? '');
      if (key) titles.set(key, t.categoryId!);
    }
  }
  return { items, titles };
}
